import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import offlinePayment from '../images/wallet-icon.svg';
import onlinePayment from '../images/credit-card-icon.svg';
import {
  loadDeliveryTypes,
  putField,
  putInputSearch,
  loadNPData,
  loadNPWarehouses,
  submitCheckout,
  changeDeliveryType,
} from '../actions/checkout';
import Select from 'react-select';
import Footer from './footer';
import loader from '../images/loader.svg';
import { Helmet } from 'react-helmet';

class Checkout extends Component {
  /**
   * Props
   *
   * @type {{isShowCompareCartWishLoader: RegExp, cartData: *}}
   */
  static props = {
    cartData: PropTypes.object,
    listPostOffices: PropTypes.object,
    isShowCompareCartWishLoader: PropTypes.bool,
    firstName: PropTypes.string,
    secondName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    deliveryTypes: PropTypes.object,
    showLoaderDeliveryTypes: PropTypes.bool,
    showUserLoader: PropTypes.bool,
    formData: PropTypes.object,
    selectedNPdata: PropTypes.object,
    inputSearchNp: PropTypes.string,
    npCities: PropTypes.object,
    selectedCity: PropTypes.string,
    warehouses: PropTypes.object,
    selectedWarehouse: PropTypes.string,
    validationData: PropTypes.object,
    orderIdCreated: PropTypes.integer,
    shopsLocal: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.timeout = 0;
  }

  componentDidMount(nextProps) {
    this.props.loadDeliveryTypes();
  }

  doSearch = (value) => {
    this.props.putInputSearch(value);
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (value.length > 0) {
        this.props.loadNPData(value);
      }
    }, 500);
  };

  render() {
    const { t } = this.props;
    const customStyles = {
      control: () => ({
        // none of react-select's styles are passed to <Control />
        display: 'flex',
        borderRadius: '0px',
        height: '100%',
        width: '100%',
      }),
    };
    if (this.props.isRedirectOnline !== false) {
      return (
        <Redirect
          to={
            '/product/redirect/external/' +
            'checkout-choose-~order_id=' +
            this.props.orderIdCreated +
            '/'
          }
        />
      );
    }

    if (this.props.isRedirectOffline !== false) {
      return (
        <Redirect
          to={
            '/product/redirect/external/' +
            'checkout-offline-status~order_id=' +
            this.props.orderIdCreated +
            '/'
          }
        />
      );
    }

    return (
      <div className='uk-container'>
        <header>
          <Helmet>
            <title>{t('checkout')}</title>
          </Helmet>
        </header>
        <div className='checkout-block uk-margin-top'>
          <h1 className='page-title uk-text-bold'>{t('checkout')}</h1>
        </div>

        {this.props.loaderCheckoutStartAction ? (
          <div className='loader-overlay  uk-position-z-index'>
            <div className='uk-position-center'>
              <img className='loader-img' alt={''} src={loader} uk-svg={''} />
            </div>
          </div>
        ) : (
          ''
        )}
        <form className='uk-grid-small' uk-grid=''>
          <div className='uk-width-2-3@m'>
            <div className='checkout-card'>
              <div className='uk-padding-small'>
                <div>
                  <h4 className='checkout-card__title'>
                    {t('checkout.yourData')}
                  </h4>
                  <input
                    className={
                      this.props.validationData['firstName']
                        ? this.props.validationData['firstName'].passed
                          ? 'uk-input uk-margin-bottom '
                          : 'uk-input  uk-form-danger'
                        : 'uk-input uk-margin-bottom'
                    }
                    value={this.props.firstName}
                    type={'text'}
                    name={'firstName'}
                    onChange={(e) => this.props.putFieldToStore(e)}
                    placeholder={t('checkout.name')}
                  />
                  <span className='uk-text-small uk-text-danger'>
                    {this.props.validationData['firstName']
                      ? this.props.validationData['firstName'].error
                        ? t(this.props.validationData['firstName'].error)
                        : ''
                      : ''}
                  </span>
                </div>
                <div className=''>
                  <input
                    className={
                      this.props.validationData['firstName']
                        ? this.props.validationData['secondName'].passed
                          ? 'uk-input uk-margin-bottom'
                          : 'uk-input uk-form-danger'
                        : 'uk-input uk-margin-bottom'
                    }
                    value={this.props.secondName}
                    type={'text'}
                    name={'secondName'}
                    onChange={(e) => this.props.putFieldToStore(e)}
                    placeholder={t('checkout.secondName')}
                  />
                  <span className='uk-text-small uk-text-danger'>
                    {this.props.validationData['secondName']
                      ? this.props.validationData['secondName'].error
                        ? t(this.props.validationData['secondName'].error)
                        : ''
                      : ''}
                  </span>
                </div>
                <div className=''>
                  <input
                    className={
                      this.props.validationData['firstName']
                        ? this.props.validationData['phone'].passed
                          ? 'uk-input uk-margin-bottom'
                          : 'uk-input uk-form-danger'
                        : 'uk-input uk-margin-bottom'
                    }
                    value={this.props.phone}
                    type={'text'}
                    name={'phone'}
                    onChange={(e) => this.props.putFieldToStore(e)}
                    placeholder='+380501234567'
                  />
                  <span className='uk-text-small uk-text-danger'>
                    {this.props.validationData['phone']
                      ? this.props.validationData['phone'].error
                        ? t(this.props.validationData['phone'].error)
                        : ''
                      : ''}
                  </span>
                </div>
                <div className=''>
                  <input
                    className={
                      this.props.validationData['firstName']
                        ? this.props.validationData['email'].passed
                          ? 'uk-input'
                          : 'uk-input uk-form-danger'
                        : 'uk-input'
                    }
                    value={this.props.email}
                    type={'text'}
                    name={'email'}
                    onChange={(e) => this.props.putFieldToStore(e)}
                    placeholder={t('checkout.email')}
                  />
                  <span className='uk-text-small uk-text-danger'>
                    {this.props.validationData['email']
                      ? this.props.validationData['email'].error
                        ? t(this.props.validationData['email'].error)
                        : ''
                      : ''}
                  </span>
                </div>
              </div>
              <div className='uk-padding-small uk-position-relative'>
                <div className=''>
                  <div
                    className={
                      this.props.showNPCityLoader
                        ? ' uk-width-small uk-position-center uk-position-z-index'
                        : 'uk-hidden'
                    }
                  >
                    <img className='loader-img' alt={''} src={loader} />
                  </div>

                  {this.props.showLoaderDeliveryTypes ? (
                    t('checkout.loadinng_delivery_type')
                  ) : (
                    <div>
                      <h4 className='checkout-card__title'>
                        {t('checkout.delivery_type')}
                      </h4>
                      <select
                        className={
                          this.props.validationData['firstName']
                            ? this.props.validationData['delivery_type'].passed
                              ? 'uk-select'
                              : 'uk-select uk-form-danger'
                            : 'uk-select'
                        }
                        name={'delivery_type'}
                        onChange={(e) => this.props.changeDeliveryType(e)}
                      >
                        {Object.keys(this.props.deliveryTypes).map((itm) => (
                          <option
                            selected={
                              this.props.formData['delivery_type'] === itm
                                ? 1
                                : ''
                            }
                            value={itm}
                          >
                            {t(this.props.deliveryTypes[itm])}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className='uk-margin'>
                    {this.props.formData['delivery_type'] === '3' ? (
                      <Select
                        className={
                          this.props.validationData['firstName']
                            ? this.props.validationData['delivery_type']
                              ? 'uk-select'
                              : 'uk-select uk-form-danger'
                            : 'uk-select'
                        }
                        options={this.props.npCities}
                        styles={customStyles}
                        components={{
                          IndicatorSeparator: () => null,
                          IndicatorsContainer: () => null,
                        }}
                        value={this.props.selectedCity}
                        isSearchable={true}
                        placeholder={t('checkout.input_city')}
                        inputValue={this.props.inputSearchNp}
                        onChange={(e) => this.props.chooseCity(e)}
                        onInputChange={(e) => this.doSearch(e)}
                        noOptionsMessage={() => t('checkout.start_input_city')}
                      />
                    ) : (
                      ''
                    )}
                    {this.props.formData['delivery_type'] === '5' ? (
                      <>
                        <div className='uk-margin'>
                          <input
                            className='uk-input '
                            name={'postIndex'}
                            type='text'
                            onChange={(e) => this.props.putFieldToStore(e)}
                            placeholder={t('checkout.ukrpost_index')}
                            value={this.props.postIndex}
                          />
                        </div>
                        <div class='uk-margin'>
                          <input
                            className='uk-input'
                            name={'regionName'}
                            type='text'
                            onChange={(e) => this.props.putFieldToStore(e)}
                            placeholder={t('checkout.ukrpost_region')}
                            value={this.props.regionName}
                          />
                        </div>
                        <div class='uk-margin'>
                          <input
                            className='uk-input '
                            name={'cityName'}
                            type='text'
                            onChange={(e) => this.props.putFieldToStore(e)}
                            placeholder={t('checkout.ukrpost_city')}
                            value={this.props.cityName}
                          />
                        </div>
                        <div class='uk-margin'>
                          <input
                            className='uk-input '
                            name={'streetName'}
                            type='text'
                            onChange={(e) => this.props.putFieldToStore(e)}
                            placeholder={t('checkout.ukrpost_street')}
                            value={this.props.streetName}
                          />
                        </div>

                        <div className='uk-grid-small' uk-grid=''>
                          <div class='uk-width-1-1 uk-width-1-2@m '>
                            <input
                              className='uk-input '
                              name={'houseNumber'}
                              type='text'
                              onChange={(e) => this.props.putFieldToStore(e)}
                              placeholder={t('checkout.ukrpost_houseNumber')}
                              value={this.props.houseNumber}
                            />
                          </div>
                          <div class='uk-width-1-1 uk-width-1-2@m '>
                            <input
                              className='uk-input '
                              name={'apartmentNumber'}
                              type='text'
                              onChange={(e) => this.props.putFieldToStore(e)}
                              placeholder={t(
                                'checkout.ukrpost_apartmentNumber'
                              )}
                              value={this.props.apartmentNumber}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ''
                    )}
                    {this.props.formData['delivery_type'] === '1' ? (
                      <div>
                        <Select
                          className={
                            this.props.validationData['firstName']
                              ? this.props.validationData['local_shops'].passed
                                ? 'uk-select'
                                : 'uk-select uk-form-danger'
                              : 'uk-select'
                          }
                          name={'local_shops'}
                          styles={customStyles}
                          components={{
                            IndicatorSeparator: () => null,
                            IndicatorsContainer: () => null,
                          }}
                          placeholder={t('checkout.select_local_shop')}
                          options={this.props.shopsLocal}
                          value={this.props.formData['local_shops']}
                          onChange={this.props.chooseShop}
                          noOptionsMessage={() => t('checkout.not_options')}
                        />
                        <span className='uk-text-small uk-text-danger'>
                          {this.props.validationData['local_shops']
                            ? this.props.validationData['local_shops'].error
                              ? t(
                                  this.props.validationData['local_shops'].error
                                )
                              : ''
                            : ''}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='uk-margin'>
                    {this.props.formData['delivery_type'] === '3' &&
                    this.props.warehouses.length > 0 ? (
                      <Select
                        className={
                          this.props.validationData['np_warehouses']
                            ? this.props.validationData['np_warehouses'].passed
                              ? 'uk-select'
                              : 'uk-select uk-form-danger'
                            : 'uk-select'
                        }
                        styles={customStyles}
                        components={{
                          IndicatorSeparator: () => null,
                          IndicatorsContainer: () => null,
                        }}
                        options={this.props.warehouses}
                        placeholder={t('checkout.select_warehouse')}
                        value={this.props.selectedWarehouse}
                        onChange={(e) => this.props.selectWarehouse(e)}
                      />
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>

              <div className='cart-block   uk-padding-small'>
                <div>
                  <div>
                    <h4 className='checkout-card__title'>
                      {t('checkout.comment')}
                    </h4>
                    <textarea
                      className='uk-textarea '
                      name={'description'}
                      onChange={(e) => this.props.putFieldToStore(e)}
                      placeholder={t('checkout.description')}
                    >
                      {this.props.description}
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='uk-width-1-3@m'>
            <div className='checkout-card '>
              {this.props.isShowCompareCartWishLoader ? (
                <div>{t('loading....')}</div>
              ) : (
                <div className={'uk-padding-small'}>
                  <h4 className='checkout-card__title'>
                    {t('checkout.your_order')}
                  </h4>
                  <table className='checkout-table uk-width-1-1'>
                    <thead className='checkout-table__head'>
                      <tr>
                        <th className='uk-text-left'>
                          {t('checkout.product')}
                        </th>
                        <th className='uk-text-right'>
                          {t('checkout.order_total')}
                        </th>
                      </tr>
                    </thead>
                    <tbody className='checkout-table__body'>
                      {this.props.cartData.data != null ? (
                        Object.keys(this.props.cartData.data).map((itm) => (
                          <tr>
                            <td className='uk-text-left '>
                              {this.props.cartData.data[itm].productName} x{' '}
                              {this.props.cartData.data[itm].count}{' '}
                              {this.props.cartData.data[itm].storageUnitUa}
                            </td>
                            <td className='uk-text-right'>
                              <span>
                                {this.props.cartData.data[itm].priceTotal}
                              </span>
                              {/* <span >{this.props.cartData.data[itm].comments}</span> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>{t('checkout.cartEmptyAddFirst')}</td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot className='checkout-table__total'>
                      <tr>
                        <td className='uk-text-bold'>{t('checkout.total')}:</td>
                        <td className='uk-text-right'>
                          {this.props.cartData.total}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
              <div className='uk-text-center uk-margin'>
                <button
                  className='checkout__payment-btn uk-button '
                  onClick={(event) => {
                    event.preventDefault();
                    this.props.submitCheckout(1);
                  }}
                >
                  <span className='checkout__payment-btn--text'>
                    {t('checkout.submit_offline')}
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* <div> */}

          {/*<button className="checkout__payment-btn"*/}
          {/*        onClick={event =>{ event.preventDefault(); this.props.submitCheckout(0)}}>*/}
          {/*    <img alt={''} className="checkout__payment-btn--icon" src={onlinePayment} uk-svg={""}/><br/>*/}
          {/*    <span className="checkout__payment-btn--text">{t("checkout.submit_online")}</span>*/}
          {/*</button>*/}
          {/* </div> */}
        </form>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { cartData, isShowCompareCartWishLoader } = store.wishCompareCart;
  const { showUserLoader } = store.user;
  const {
    deliveryTypes,
    showNPCityLoader,
    loaderCheckoutStartAction,
    showLoaderDeliveryTypes,
    formData,
    inputSearchNp,
    npCities,
    warehouses,
    validationData,
    isRedirectOnline,
    orderIdCreated,
    isRedirectOffline,
    shopsLocal,
  } = store.checkoutInfo;
  // console.log("delivery type ", typeof formData['delivery_type']);
  return {
    cartData,
    showNPCityLoader,
    isShowCompareCartWishLoader,
    deliveryTypes,
    showLoaderDeliveryTypes,
    showUserLoader,
    firstName: formData.firstName ? formData.firstName : '',
    secondName: formData.secondName ? formData.secondName : '',
    phone: formData.phone ? formData.phone : '',
    email: formData.email ? formData.email : '',
    formData: formData,
    description: formData.description ? formData.description : '',
    inputSearchNp,
    npCities,
    selectedCity: formData.delivery_city ? formData.delivery_city : '',
    warehouses,
    selectedWarehouse: formData.np_warehouses ? formData.np_warehouses : '',
    validationData,
    isRedirectOnline,
    orderIdCreated,
    isRedirectOffline,
    shopsLocal,
    loaderCheckoutStartAction,
    //for_Ukrposhta//////////////////////////////////
    postIndex: formData.postIndex ? formData.postIndex : '',
    regionName: formData.regionName ? formData.regionName : '',
    cityName: formData.cityName ? formData.cityName : '',
    streetName: formData.streetName ? formData.streetName : '',
    houseNumber: formData.houseNumber ? formData.houseNumber : '',
    apartmentNumber: formData.apartmentNumber ? formData.apartmentNumber : '',
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    putFieldToStore: (event) => {
      dispatch(putField(event.target.name, event.target.value));
    },
    putInputSearch: (value) => {
      dispatch(putInputSearch(value));
    },

    loadNPData: (values) => {
      dispatch(loadNPData(values));
    },

    loadDeliveryTypes: () => {
      dispatch(loadDeliveryTypes());
    },
    chooseCity: (city) => {
      dispatch(putField('delivery_city', city));
      dispatch(loadNPWarehouses());
    },
    chooseShop: (shop) => {
      dispatch(putField('local_shops', shop));
    },
    submitCheckout: (isOffline) => {
      dispatch(submitCheckout(isOffline));
    },
    selectWarehouse: (warehouse) => {
      dispatch(putField('np_warehouses', warehouse));
    },
    changeDeliveryType: (e) => {
      dispatch(changeDeliveryType(e.target.value));
    },
  };
};

const CheckoutList = withTranslation('translations')(Checkout);

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutList);
